export default [
  {
    language: 'ru',
    code: '7'
  },
  {
    language: 'en',
    code: '1'
  },
  {
    language: 'en-GB',
    code: '1'
  },
  {
    language: 'en-US',
    code: '1'
  },
  {
    language: 'en-AU',
    code: '1'
  },
  {
    language: 'en-CA',
    code: '1'
  },
  {
    language: 'en-IN',
    code: '1'
  },
  {
    language: 'en-NZ',
    code: '1'
  },
  {
    language: 'en-IE',
    code: '1'
  },
  {
    language: 'en-ZA',
    code: '1'
  },
  {
    language: 'en-GB-oxendict',
    code: '1'
  },
  {
    language: 'vi',
    code: '84'
  },
  {
    language: 'fr',
    code: '33'
  },
  {
    language: 'fr-CA',
    code: '33'
  },
  {
    language: 'fr-FR',
    code: '33'
  },
  {
    language: 'fr-CH',
    code: '33'
  },
  {
    language: 'uk',
    code: ''
  },
  {
    language: 'fa',
    code: '98'
  },
  {
    language: 'ja',
    code: '81'
  },
  {
    language: 'es',
    code: ''
  },
  {
    language: 'es-AR',
    code: ''
  },
  {
    language: 'es-CL',
    code: ''
  },
  {
    language: 'es-CO',
    code: ''
  },
  {
    language: 'es-CR',
    code: ''
  },
  {
    language: 'es-HN',
    code: ''
  },
  {
    language: 'es-419',
    code: ''
  },
  {
    language: 'es-MX',
    code: ''
  },
  {
    language: 'es-PE',
    code: ''
  },
  {
    language: 'es-ES',
    code: ''
  },
  {
    language: 'es-US',
    code: ''
  },
  {
    language: 'es-UY',
    code: ''
  },
  {
    language: 'es-VE',
    code: ''
  },
  {
    language: 'ko',
    code: '82'
  },
  {
    language: 'zh',
    code: ''
  },
  {
    language: 'zh-CN',
    code: ''
  },
  {
    language: 'zh-HK',
    code: ''
  },
  {
    language: 'zh-TW',
    code: ''
  },
  {
    language: 'pt',
    code: '55'
  },
  {
    language: 'pt-BR',
    code: '55'
  },
  {
    language: 'pt-PT',
    code: '55'
  }
  ]


// WEBPACK FOOTER //
// ./src/utils/languageAreaCode.js